export default __webpack_public_path__ + "static/PJATK_shop-1-8a0441e51be89d6c40c8a273ca1b9400.png";